/**
 * Configuration for jobs in this app.
 */
const jobiqoJobsConfig = require('./../jobs');
const R = require('ramda');

module.exports = R.mergeDeepRight(jobiqoJobsConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    GEO_INFO: {
      fixtures: [
        {
          label: 'Monterey, CA, USA',
          location: { lat: 36.6002, lng: -121.8947 },
        },
        {
          label: 'Salinas, CA, USA',
          location: { lat: 36.6777, lng: -121.6555 },
        },
        {
          label: 'Santa Cruz, CA, USA',
          location: { lat: 36.9741, lng: -122.0308 },
        },
        {
          label: 'Watsonville, CA, USA',
          location: { lat: 36.9102, lng: -121.7569 },
        },
        {
          label: 'Carmel, CA, USA',
          location: { lat: 36.5552, lng: -121.9233 },
        },
        {
          label: 'Seaside, CA, USA',
          location: { lat: 36.6111, lng: -121.8517 },
        },
        {
          label: 'Pacific Grove, CA, USA',
          location: { lat: 36.6177, lng: -121.9166 },
        },
        {
          label: 'Marina, CA, USA',
          location: { lat: 36.6844, lng: -121.8022 },
        },
      ]
    },
  },
});
